// extracted by mini-css-extract-plugin
export default {"container":"FieldPriceIncludeVAT_container__fuHz0"};